import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { exigir } from '../../nucleo/autorizacion/guardian.js';
import { rutaEgresos } from '../_egresos.js';

/**
 * Registrar y pagar una compra. Fase 8, tarea 24.
 *
 * EN `_egresos` PORQUE `compra.registrar` SON LOS CUATRO ROLES, el mismo conjunto que
 * `gastoCajaMenor.registrar`, que es la llave de este grupo. El bloque la colgaba de `_operacion` como
 * `/jornada/compras`, y ese grupo deja fuera a la contadora, que también registra compras. Una compra no
 * es parte de la jornada: se paga, muchas veces, desde la caja menor, como un gasto.
 *
 * El componente llega a pedido, como los demás hijos de este grupo.
 *
 * DESDE EL 2026-10-01 TIENE GUARDIÁN PROPIO: el dueño del negocio le quitó las compras por proveedor
 * al operario y al jefe, y `compra.registrar` quedó en la contadora y el administrador. El grupo
 * sigue dejándolos entrar a registrar gastos.
 */
export const rutaCompras = createRoute({
  getParentRoute: () => rutaEgresos,
  path: '/compras',
  beforeLoad: ({ context }) => ({ sesion: exigir(context, { accion: 'compra.registrar' }) }),
  component: lazyRouteComponent(() => import('./compras-pantalla.js'), 'RutaCompras'),
});
